import { Box, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type Status from 'modules/integrations_primobox/lib/interfaces/Status'

interface Props {
  onClose: () => void
  status: Status
}

const ErrorModal = ({ status, onClose }: Props) => {
  return (
    <Modal
      illustration="alert"
      title={i18n.t('integrations_primobox.error_modal.title')}
      description={i18n.t('integrations_primobox.error_modal.description')}
      onClose={onClose}
    >
      <Box borderRadius={{ all: 'abs008' }} background="champagne400" paddingX="s24" paddingY="s16">
        {status.messages.map((message, index) => (
          <Text.Normal key={index} color="grey1000" size="300">
            {message}
          </Text.Normal>
        ))}
      </Box>
      <Box paddingY="s24">
        <Text.Normal size="300">
          {i18n.t('integrations_primobox.error_modal.next_sync')}
        </Text.Normal>
      </Box>
    </Modal>
  )
}

export default ErrorModal
